export const specialities = '/specialities';
export const speciality = (id: number) => `/specialities/${id}`;
